var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "standard-button noselect", class: _vm.classes },
    [_vm.loading === false ? [_vm._v(_vm._s(_vm.text))] : _c("plain-spinner")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }